module.exports = __webpack_public_path__ + "img/droplet.8ebbbb16.svg";